import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {SiteService} from "./site.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {FilteredList} from "../helpers/filtered-list";
import {exposeComponentInDebugMode} from "../misc/expose-component-in-debug-mode.decorator";
import {K2SiteModel} from "./k2-site.model";
import {toggleLoading} from "../misc/loading.decorator";
import {JSONModel} from "../json.model";

export interface ImportK2SitesInputModel {
  projectId: string;
}

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 5;

@Component({
  templateUrl: "./import-k2-sites-dialog.template.pug",
  providers: [
    SiteService,
  ],
})
@exposeComponentInDebugMode()
export class ImportK2SitesDialogComponent extends DialogComponent<ImportK2SitesInputModel, boolean>
  implements ImportK2SitesInputModel {
  projectId: string;
  error: Error;
  orderName: string;
  selectedCount: number = 0;

  k2Sites: FilteredList<K2SiteModel> = new FilteredList<K2SiteModel>({
    startingPageSize: 5,
    searchKeys: ["name"],
    formKeys: ["selected"],
  });

  loading: boolean = true;

  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number = 1;
  searchText: string = "";

  static showImportK2SitesDialogModal(dialogService: DialogService, input: ImportK2SitesInputModel): Promise<boolean> {
    return dialogService.showDialog(ImportK2SitesDialogComponent, input);
  }

  constructor(
    public dialogService: DialogService,
    private siteService: SiteService,
  ) {
    super(dialogService);

    this.result = false;
  }

  cancel(): void {
    this.close();
  }

  @handleErrors()
  async importSites() {
    const sites = this.k2Sites.items.filter(it => it.selected);
    await this.siteService.insertK2Sites(this.projectId, sites);
    this.result = true;
    this.close();
  }

  deselectAll(): void {
    this.k2Sites.forEachSearchFiltered((fg) => {
      fg.controls["selected"].setValue(false);
    });

    this.updateSelection();
  }

  selectAll(): void {
    this.k2Sites.forEachSearchFiltered((fg) => {
      fg.controls["selected"].setValue(true);
    });

    this.updateSelection();
  }

  @toggleLoading()
  @handleErrors()
  async ready() {
    const sites = await this.siteService.loadSitesFromK2ToImport(this.projectId);
    JSONModel.reIndexList(sites);

    this.k2Sites.items = sites;

    this.deselectAll();
  }

  updateSelection(): void {
    this.selectedCount = this.k2Sites.items.filter(it => it.selected).length;
  }
}
